import React, { useState, useEffect } from "react"
import { Navbar } from "react-bootstrap"
import { Link } from "gatsby"
import { navLinks } from "@config"
import { useScrollDirection, usePrefersReducedMotion } from "@hooks"
import styled, { css } from "styled-components"

const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  z-index: 11;
  width: 100%;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 6);
  filter: none !important;
  pointer-events: auto !important;
  user-select: auto !important;
  backdrop-filter: blur(10px);
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 6);

  @media (prefers-reduced-motion: no-preference) {
    ${props =>
      props.scrollDirection === "up" &&
      !props.scrolledToTop &&
      css`
        height: rgba(2, 12, 27, 0.7);
        transform: translateY(0px);
        background-color: #020c1b; // come back to it
        box-shadow: 0 8px 33px -12px rgba(2, 12, 27, 0.7);
      `};

    ${props =>
      props.scrollDirection === "down" &&
      !props.scrolledToTop &&
      css`
        height: rgba(2, 12, 27, 0.7);
        transform: translateY(0px);
        background-color: #020c1b; // come back to it
        box-shadow: 0 8px 33px -12px rgba(2, 12, 27, 0.7);
      `};
  }
`

const StyledNav = styled.nav`
  position: relative;
  width: 100%;
  counter-reset: item 0;
  z-index: 12;
  .nav-brand {
    color: #05d9e8;
    font-weight: bold;
    font-family: "Poppins", sans-serif;
    text-decoration: none;
    span {
      color: #f5fffa !important;
    }
    &:hover {
      color: #e4e2f3 !important;
      transition: all 0.3s linear;
    }
  }
`

const StyledLinks = styled.div`
  ol {
    list-style-type: none;
    display: flex;

    li {
      margin: 0 16px;
      position: relative;
      counter-increment: item 1;
      font-size: 12px;

      a {
        letter-spacing: 2px;
        display: block;
        text-decoration: none;
        text-decoration-skip-ink: auto;
        color: #f5fffa !important;
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

        &:hover {
          color: #e4e2f3 !important;
          transition: all 0.3s linear;
        }
        &:before {
          content: "0" counter(item) ".";
          margin-right: 4px;
          color: #05d9e8;
          font-size: 12px;
          text-align: right;
        }
      }
    }

    .resume-button {
      font-size: 12px;
      color: #d1f7ff;
      background-color: transparent;
      border: 1px solid #d1f7ff;
      border-radius: 4px;
      font-family: poppins;
      line-height: 1;
      text-decoration: none;
      cursor: pointer;
      transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
      padding: 1.25rem 1.75rem;

      &:hover,
      &:focus,
      &:active {
        background-color: rgba(100, 255, 218, 0.1);
        outline: none;
      }
      &:after {
        display: none !important;
      }
    }
  }

  @media screen and (max-width: 812px) {
    ol {
      display: flex;
      margin-top: 64px;
      flex-direction: column;
      margin-bottom: 64px;
    }
    li {
      a {
        letter-spacing: 4px !important;
        display: block;
        text-decoration: none;
        text-decoration-skip-ink: auto;
        color: #e6f1ff !important;
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
    }
  }
`

export default function NavContainer({ isHome }) {
  const [isMounted, setIsMounted] = useState(!isHome)
  const scrollDirection = useScrollDirection("down")
  const [scrolledToTop, setScrolledToTop] = useState(true)
  const prefersReducedMotion = usePrefersReducedMotion()

  const handleScroll = () => {
    setScrolledToTop(window.pageYOffset < 60)
  }
  useEffect(() => {
    if (prefersReducedMotion) {
      return
    }

    const timeout = setTimeout(() => {
      setIsMounted(true)
    }, 100)

    window.addEventListener("scroll", handleScroll)

    return () => {
      clearTimeout(timeout)
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const ResumeLink = (
    <a
      className="resume-button"
      href="https://resume.io/r/SIYaE3zTH"
      target="_blank"
      rel="noopener noreferrer"
    >
      Resume
    </a>
  )

  return (
    <StyledHeader
      scrollDirection={scrollDirection}
      scrolledToTop={scrolledToTop}
    >
      <StyledNav>
        <Navbar className="container " bg="" expand="lg">
          <Link to="/" className="nav-brand">
            Noah<span className="nav-brand-span">Ben</span>
          </Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span class="navbar-toggler-icon hamburger">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </Navbar.Toggle>
          <Navbar.Collapse
            className="justify-content-end"
            id="basic-navbar-nav "
          >
            <StyledLinks>
              <ol className="">
                {navLinks &&
                  navLinks.map(({ url, name }, i) => (
                    <li className="nav-item" key={i}>
                      <Link className="nav-link" to={url}>
                        {name}
                      </Link>
                    </li>
                  ))}
                <br></br>
                {ResumeLink}
              </ol>
            </StyledLinks>
          </Navbar.Collapse>
        </Navbar>
      </StyledNav>
    </StyledHeader>
  )
}
